/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return n instanceof Float32Array&&n.length>=4}function r(n){return Array.isArray(n)&&n.length>=4}function t(t){return n(t)||r(t)}export{t as isVec4,n as isVec4f32,r as isVec4f64};
